export const fontPath = '/fonts/IBMPlexSans.css';
